import React from 'react'
import PropTypes from 'prop-types'
import Table from 'shared/components/common/Table/Table.component'
import RowTabItems from 'shared/components/common/RowTabItems/RowTabItems.component'

import styles from './TableChart.module.scss'

import iconBarChart from 'shared/assets/icons/bar-chart-24px.svg'
import iconTableChart from 'shared/assets/icons/table-chart-24px.svg'
import iconArrowLeft from 'shared/assets/icons/keyboard-arrow-left-24px.svg'
import iconArrowRight from 'shared/assets/icons/keyboard-arrow-right-24px.svg'
import iconLineChart from 'shared/assets/icons/line-chart-24px.svg'

const setColumnName = (key, table) => {
  switch(key) {
    case `${table}.eventname`: {
      return 'Type'
    }
    case `${table}.channelname`: {
      return 'Channel'
    }
    case `${table}.originatorrole`: {
      return 'Role'
    }
    case `${table}.count`: {
      return 'Count'
    }

    default: return key
  }
}

const setDefaultBarItem = defaultChartType => {
  switch (defaultChartType) {
    case 'bar': {
      return { icon: iconBarChart, action: 'bar' }
    }

    case 'line': {
      return { icon: iconLineChart, action: 'line' }
    }
  }
}

const TableChart = ({
  table,
  resultSet,
  chartType,
  onChangeChartType,
  onMoveCustomDateRange,
  tableDataMapHandler,
  defaultChartType
}) => {
  const columns = resultSet.tableColumns().map(item => setColumnName(item.key, table))
  const data = resultSet.tablePivot().map(tableDataMapHandler)
  
  return <main className={styles.table}>
    <header className={styles.header}>
      <RowTabItems
        items={[
          { icon: iconArrowLeft, action: 'back', iconInlineStyles: { height: '20px' } },
          { icon: iconArrowRight, action: 'forward', iconInlineStyles: { height: '20px' } }
        ]}
        onClick={onMoveCustomDateRange}
      />
      
      <RowTabItems
        activeAction={chartType}
        items={[
          setDefaultBarItem(defaultChartType),
          { icon: iconTableChart, action: 'table', iconInlineStyles: { height: '16px' } }
        ]}
        onClick={onChangeChartType}
      />
    </header>

    <br />

    <Table columns={columns} data={data}/>
  </main>
}

TableChart.propTypes = {
  defaultChartType: PropTypes.string,
  resultSet: PropTypes.object,
  table: PropTypes.string.isRequired,
  chartType: PropTypes.string.isRequired,
  onChangeChartType: PropTypes.func.isRequired,
  onMoveCustomDateRange: PropTypes.func.isRequired,
  tableDataMapHandler: PropTypes.func.isRequired
}

export default TableChart
